import moment from 'moment';

export const getDateOneMonthAgo = (): string => {
  const lastMonth = moment().subtract('1', 'month');
  return lastMonth.format('YYYY-MM-DD');
};
